export const REQUEST_LOGIN = '@auth/login__request';
export const SUCCESS_LOGIN = '@auth/login__success';
export const FAILURE_LOGIN = '@auth/login__failure';

export const REQUEST_LOGOUT = '@auth/logout__request';

export const SET_COMPANY_SELECTED = '@app/company__set';
export const APP_LOADING = '@app/loading';
